

export class TyreModelOutputWithStatus implements ITyreModelOutputWithStatus {
    /** The auto-generated id of the tyre model master */
    tyre_model_id!: number;
    /** The tyre model name with 255 character limit */
    tyre_model_name!: string;
    /** Manage status of tyre model. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITyreModelOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_model_id = _data["tyre_model_id"];
            this.tyre_model_name = _data["tyre_model_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreModelOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TyreModelOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_model_id"] = this.tyre_model_id;
        data["tyre_model_name"] = this.tyre_model_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreModelOutputWithStatus {
    /** The auto-generated id of the tyre model master */
    tyre_model_id: number;
    /** The tyre model name with 255 character limit */
    tyre_model_name: string;
    /** Manage status of tyre model. 0 For De-active, 1 For Active */
    status: number;
}

